import { Tabs } from "antd";
import LoyaltyTab from "pages/customers/LoyaltyTab";
import ReferralTab from "pages/customers/ReferralTab.component";
import { useTabParam } from "hooks/useTabParam";
import { translate } from "shared/languages";
import { User } from "shared/types";

// Customer detail tab "5" — Reward: the loyalty card (existing LoyaltyTab)
// and the referral pane as sub-tabs. The sub-tab lives in its own URL param
// `reward` (NOT `sub`, which the Paket/Membership panes already use — a
// shared name would collide on one URL).
const RewardTab = ({ customer }: { customer: User }) => {
  const { activeKey, onChange } = useTabParam("loyalty", "reward", [
    "loyalty",
    "referral",
  ]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      items={[
        {
          key: "loyalty",
          label: translate("tabs.loyalty"),
          children: <LoyaltyTab customer={customer} />,
        },
        {
          key: "referral",
          label: translate("tabs.referral"),
          children: <ReferralTab customer={customer} />,
        },
      ]}
    />
  );
};

export default RewardTab;
